// @flow
import * as React from 'react';
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import Emoji from "a11y-react-emoji";
import DialogContent from "@material-ui/core/DialogContent";
import Typography from "@material-ui/core/Typography";
import Box from "@material-ui/core/Box";

function ScheduleGameCardFooterStreamButton({buttonProps}: Props) {
  const [open, setOpen] = React.useState(false);
  return (
    <>
      <Button
        size="small"
        variant="contained"
        color="primary"
        onClick={() => setOpen(true)}
        {...buttonProps}
      >
        Live-Stream anschauen
      </Button>
      <Dialog
        onClose={() => setOpen(false)}
        aria-labelledby="simple-dialog-title"
        open={open}
        maxWidth="sm"
      >
        <DialogTitle id="simple-dialog-title">Live-Stream <Emoji symbol="📹" /></DialogTitle>
        <DialogContent>
          <Typography>
            Fieber mit im kostenlosen SG Coesfeld Live-Stream. Dieser <b>startet 15-30&nbsp;Minuten vor Spielbeginn</b> und wird auf dem Streaming-Portal Twitch für dich bereit gestellt.
          </Typography>
          <Box mt={2} mb={1}>
            <Button fullWidth autoFocus onClick={() => {
              window.open("https://twitch.tv/sgcoesfeld", "_blank");
            }} color="primary" variant="contained">
              Weiter zum Live-Stream
            </Button>
          </Box>
        </DialogContent>
      </Dialog>
      </>
  );
}

export default ScheduleGameCardFooterStreamButton;
